import { render, staticRenderFns, recyclableRender, components } from "./uni-popup.vue?vue&type=template&id=7da806a4&scoped=true&"
var renderjs
import script from "./uni-popup.vue?vue&type=script&lang=js&"
export * from "./uni-popup.vue?vue&type=script&lang=js&"
import style0 from "./uni-popup.vue?vue&type=style&index=0&id=7da806a4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!E:\\HBuilderX\\plugins\\uniapp-cli\\node_modules\\@dcloudio\\vue-cli-plugin-uni\\packages\\vue-loader\\lib\\runtime\\componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7da806a4",
  null,
  false,
  components,
  renderjs
)

component.options.__file = "components/uni-popup/uni-popup.vue"
export default component.exports